<script setup lang="ts">
import type { CardsSectionData } from '~/utils/crystallize/pieces'
import { byPublishedDate } from '~/utils/crystallize/article'

// FIXME: In theory, this inline type should be replacable with the CardsSectionData type directly, since all field names are the same, but Vue doesn't like that for some reason.
const { maxCount, title = 'Aktuelt', showOverviewLink } = defineProps<{
  maxCount: CardsSectionData['maxCount']
  title?: CardsSectionData['title']
  showOverviewLink: CardsSectionData['showOverviewLink']
}>()

const { data } = useArticles()

const all = computed(() => {
  const raw = data.value?.children ?? []
  return [...raw].sort(byPublishedDate)
})

const articles = computed(() => typeof maxCount === 'number' ? all.value.slice(0, maxCount) : all.value)
</script>

<template>
  <ClientOnly>
    <ContentGrid is="section" v-if="articles.length" class="w-full py-xl gap-y-s lg:gap-y-l">
      <div class="full-width-content flex justify-between items-center">
        <h2 class="title-l" v-text="title" />
        <LinkButton v-if="showOverviewLink" size="medium" variant="primary" :to="{ name: 'articles-index' }">
          Se mer
        </LinkButton>
      </div>
      <!-- FIXME: Card padding, should be aligned with grid, now indented. -->
      <NettbutikkArticleCardList :articles="articles" class="hidden lg:grid full-width-content" />
      <Carousel v-slot="{ item }" class="lg:hidden full-width-content [--item-width:80%]" :data="all" variant="nettbutikk">
        <NettbutikkArticleCard :article="item" />
      </Carousel>
    </ContentGrid>
  </ClientOnly>
</template>
